module.exports = __webpack_public_path__ + "static/img/sc2.4cd7de8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc2.png
// module id = mJAI
// module chunks = 25